import { SelectTrigger, SelectValue } from "@radix-ui/react-select";
import { Select, SelectContent, SelectItem } from "@/components/ui/select";
import "./NewsDropdown.css";
import type React from "react";
import { useEffect, useState } from "react";
import type { DropdownProps } from "@/components/mosaic/ui/TileTitle/TileTitle";
import { isTickerFilter } from "../../../lib/helpers/isTickerFilter";
import { TICKER_FILTER } from "../../../types";

const values: Record<TICKER_FILTER, string> = {
	[TICKER_FILTER.ALL]: "All",
	[TICKER_FILTER.TOP]: "Top 500",
	[TICKER_FILTER.OTHER]: "Other",
};

type Props = {
	tileId: string;
};

export const NewsDropdown: React.FC<Props & DropdownProps> = ({
	state,
	onStateChange,
}) => {
	const tickerFilter = (
		!state?.ticker
			? !state?.tickerFilter
				? TICKER_FILTER.ALL
				: state.tickerFilter
			: state?.ticker
	) as TICKER_FILTER;

	const [selectedTickerFilter, setSelectedTickerFilter] =
		useState<TICKER_FILTER>(tickerFilter as TICKER_FILTER);

	useEffect(() => {
		setSelectedTickerFilter(tickerFilter as TICKER_FILTER);
	}, [tickerFilter]);

	return (
		<Select
			value={selectedTickerFilter}
			onValueChange={(value) =>
				onValueChange(value, setSelectedTickerFilter, onStateChange)
			}
		>
			<SelectTrigger className="w-[50px] news-select-trigger text-gold font-bold text-sm">
				<SelectValue data-testid="selectedValue">
					{values[tickerFilter] || tickerFilter}
				</SelectValue>
			</SelectTrigger>

			<SelectContent align="start">
				<SelectItem value={TICKER_FILTER.ALL}>All</SelectItem>
				<SelectItem value={TICKER_FILTER.TOP}>Top 500</SelectItem>
				<SelectItem value={TICKER_FILTER.OTHER}>Other</SelectItem>
			</SelectContent>
		</Select>
	);
};

export function onValueChange(
	value: string,
	setSelectedTicker: (value: TICKER_FILTER) => void,
	onStateChange: (state: Record<string, unknown>) => void,
) {
	setSelectedTicker(value as TICKER_FILTER);
	onStateChange({
		ticker: isTickerFilter(value) ? "" : value,
		tickerFilter: value,
	});
}
